<div class="row-wrapper">
  <div *ngIf="!isMobile && textValue" class="col-wrapper url-wrapper">
    <input [value]="textValue" type="text" readonly />
  </div>
  <div class="col-wrapper ms-auto ps-4">
    <app-button-transparent [disabled]="!textValue" (clicked)="copyMessage()" icon="content_copy" text="Copy">
    </app-button-transparent>
  </div>
</div>
